import { combineReducers } from 'redux';
import { postsReducer } from '../modules/posts';
import { aggregationsReducer } from '../modules/aggregations';
import { tintReducer } from '../modules/tint';
import { configReducer } from '../modules/config';
import { messagesReducer } from '../modules/messages';

export const rootReducer = combineReducers({
  posts: postsReducer,
  aggregations: aggregationsReducer,
  tint: tintReducer,
  config: configReducer,
  messages: messagesReducer,
});
export type RootState = ReturnType<typeof rootReducer>;
